<template>
  <DYErrorPage :error="error">
    <template #forAdmin>
      <div v-if="userStore.isSignedIn && !isAdmin">
        유저 권한으로 로그인되어 있습니다. 로그아웃 후 재로그인 해주세요.
        <DYLogoutLink v-slot="{ requestLogout }">
          <v-btn class="mr-5 text-white" color="red" prepend-icon="fa-sign-out" @click="clickLogout">로그아웃</v-btn>
        </DYLogoutLink>
      </div>
    </template>
  </DYErrorPage>
</template>

<script setup lang="ts">
import Template from "~/modules/nuxt3-module-admin-ingang/pages/coupon/template.vue";
import { useDYAuth } from "~/modules/nuxt3-module-doyac/composables/auth";
const router = useRouter()
const route = useRoute()
const { isAdmin } = useDYAuth()
const userStore = useUserStore();

const props = defineProps({
  error: Object
})

const statusCode = computed(() => props.error?.statusCode ?? 404)
const title = computed(() => `에러: ${statusCode}`)

const config = useAppConfig()


const _saveCurrentUrl = () => {
  const redirect = useCookie('auth.redirect')
  redirect.value = route.fullPath

  // 이전 페이지를 기록할 때 basePath도 기록해야 함. basePath는 관리자 앱이냐 일반 유저 앱이냐에 따라 달라지는데
  // 로그인 성공 후 이동되는 URL에는 기본적으로 basePath가 포함되지 않기 때문에 이전 페이지가 어디서 왔는지 알기
  // 위해서 필요함.
  const basePath = useCookie('auth.basePath')
  basePath.value = config.basePath as string
}

const clickLogout = async () => {
  await userStore.requestLogout();
  _saveCurrentUrl()
  router.push('/login')
}

useHead({
  meta: [{ content: title }],
  titleTemplate: (titleChunk) => titleChunk ? `${titleChunk} - ${title}` : config.appName
})
</script>
